import { useGetWebinarsQuery } from '../../../__generated__/chirp/com/hubspot/video/conference/component/rpc/ui/service/v1/WebinarsChirpUIService.hooks';
import { useState, useCallback } from 'react';
import { getUniqueAndSortedOptions, getOptions } from '../utils/webinarFormUtils';
import { EVENT_STATUS } from '../constants';
import { addFailureFloatingAlert } from '../../common/utils/alerts';
import { errorLabels } from '../../common/utils/errorUtils';
import { ErrorsType } from '../../common/constants/commonConstants';
export const useFutureWebinars = (appId, webinarId) => {
  var _data$getWebinars2, _data$getWebinars3, _data$getWebinars4;
  const [webinarSearchData, setWebinarSearchData] = useState({
    searchValue: '',
    isLoadingDropDownFooter: false
  });
  const {
    loading,
    error,
    data,
    refetch,
    fetchMore
  } = useGetWebinarsQuery({
    variables: {
      appId,
      eventStatus: EVENT_STATUS.UPCOMING,
      selectedWebinarId: webinarId
    },
    useLegacyFieldNameMode: true
  });
  const loadMore = useCallback(async () => {
    setWebinarSearchData(prev => Object.assign({}, prev, {
      isLoadingDropDownFooter: true
    }));
    try {
      var _data$getWebinars;
      return await fetchMore({
        variables: {
          selectedWebinarId: undefined,
          searchQuery: webinarSearchData.searchValue,
          nextCursor: data === null || data === void 0 || (_data$getWebinars = data.getWebinars) === null || _data$getWebinars === void 0 ? void 0 : _data$getWebinars.after
        },
        updateQuery: (previousResult, {
          fetchMoreResult
        }) => {
          var _previousResult$resul, _fetchMoreResult$resu, _fetchMoreResult$resu2;
          setWebinarSearchData(prev => Object.assign({}, prev, {
            isLoadingDropDownFooter: false
          }));
          return {
            result: {
              webinars: [...(((_previousResult$resul = previousResult.result) === null || _previousResult$resul === void 0 ? void 0 : _previousResult$resul.webinars) || []), ...(((_fetchMoreResult$resu = fetchMoreResult.result) === null || _fetchMoreResult$resu === void 0 ? void 0 : _fetchMoreResult$resu.webinars) || [])],
              after: (_fetchMoreResult$resu2 = fetchMoreResult.result) === null || _fetchMoreResult$resu2 === void 0 ? void 0 : _fetchMoreResult$resu2.after
            }
          };
        }
      });
    } catch (e) {
      setWebinarSearchData(prev => Object.assign({}, prev, {
        isLoadingDropDownFooter: false
      }));
      addFailureFloatingAlert(errorLabels[ErrorsType.GET_WEBINARS_ERROR], true);
    }
  }, [webinarSearchData.searchValue, data === null || data === void 0 || (_data$getWebinars2 = data.getWebinars) === null || _data$getWebinars2 === void 0 ? void 0 : _data$getWebinars2.after, fetchMore]);
  const search = useCallback(searchValue => {
    setWebinarSearchData({
      searchValue,
      isLoadingDropDownFooter: true
    });
    refetch({
      selectedWebinarId: webinarId,
      searchQuery: searchValue
    }).catch(() => {
      addFailureFloatingAlert(errorLabels[ErrorsType.GET_WEBINARS_ERROR], true);
    }).finally(() => setWebinarSearchData(prev => Object.assign({}, prev, {
      isLoadingDropDownFooter: false
    })));
  }, [refetch, webinarId]);
  return Object.assign({}, webinarSearchData, {
    futureWebinars: getUniqueAndSortedOptions(getOptions((data === null || data === void 0 || (_data$getWebinars3 = data.getWebinars) === null || _data$getWebinars3 === void 0 ? void 0 : _data$getWebinars3.webinars) || [])),
    nextCursor: data === null || data === void 0 || (_data$getWebinars4 = data.getWebinars) === null || _data$getWebinars4 === void 0 ? void 0 : _data$getWebinars4.after,
    isLoading: loading,
    error,
    search,
    loadMore
  });
};